import { addDays, addWeeks, endOfDay, isAfter, startOfDay, subDays, subWeeks } from "date-fns"

type GanttZoomRange = {
  start: Date
  end: Date
}

type GetGanttVisibleRangeArgs = {
  startDate?: Date | number | null
  endDate?: Date | number | null
  paddingDays?: number
}

const DEFAULT_VISIBLE_WEEKS = 4
const DEFAULT_PADDING_DAYS = 2

const toDate = (value?: Date | number | null): Date | null => {
  if (value == null) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

const buildDefaultRange = (paddingDays: number): GanttZoomRange => {
  const now = new Date()
  const start = startOfDay(subDays(now, paddingDays))
  const end = endOfDay(addDays(addWeeks(now, DEFAULT_VISIBLE_WEEKS), paddingDays))
  return { start, end }
}

export const getGanttVisibleRange = ({
  startDate,
  endDate,
  paddingDays = DEFAULT_PADDING_DAYS,
}: GetGanttVisibleRangeArgs = {}): GanttZoomRange => {
  const startInput = toDate(startDate)
  const endInput = toDate(endDate)

  let actualStart: Date
  let actualEnd: Date

  // Resolve base range
  if (startInput && endInput) {
    if (isAfter(startInput, endInput)) {
      return buildDefaultRange(paddingDays)
    }
    actualStart = startInput
    actualEnd = endInput
  } else if (startInput) {
    actualStart = startInput
    actualEnd = addWeeks(startInput, DEFAULT_VISIBLE_WEEKS)
  } else if (endInput) {
    actualStart = subWeeks(endInput, DEFAULT_VISIBLE_WEEKS)
    actualEnd = endInput
  } else {
    return buildDefaultRange(paddingDays)
  }

  // Apply padding + normalization
  const paddedStart = startOfDay(subDays(actualStart, paddingDays))
  const paddedEnd = endOfDay(addDays(actualEnd, paddingDays))

  return { start: paddedStart, end: paddedEnd }
}
